<template>
  <section class="section chatGroup" :class="{open: show}"
    v-on:click="sectionClicked">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Chat Group</h4>
          <button class="createGroup" v-on:click="createGroup">Create Group</button>
        </div>
        <div class="contentSc">
          <div class="loadingGroup" v-if="loading"></div>
          <div class="noGroup" v-else-if="groups.length < 1">
            <!-- <img src="../assets/Sedih-Lili-1.png"> -->
            <h4>Kamu Belum Bergabung Grup</h4>
            <p>Buat grup atau minta leader grup yang kamu kenal untuk
              mengundang kamu ke dalam grupnya.</p>
            <button v-on:click="createGroup">Buat Grup</button>
          </div>
          <div class="groupCnt" v-else>
            <div class="groupItem" v-for="(item, i) in groups" :key="i"
              :class="{moreOpen: moreId === item.id}"
              v-on:click="openDetail(i, item)">
              <div class="groupAvatar" :class="{noImg: !item.avatar || item.avatar === ''}"
                :style="{'background-image': `url(${item.avatar})`}"></div>
              <h4 v-if="item.name">{{item.name}}</h4>
              <h4 v-else>No name</h4>
              <div v-if="item.lastMessage">
                <p v-if="item.lastMessage.message">
                  {{item.lastMessage.message}}</p>
                <p v-else-if="item.lastMessage.sticker">
                  <i>{{item.lastMessage.name}} mengirimkan sticker</i></p>
                <p v-else-if="item.lastMessage.profile">
                  <i>{{item.lastMessage.name}} mengirimkan profil challenge</i></p>
                <p v-else-if="item.lastMessage.finisher">
                  <i>{{item.lastMessage.name}} mengirimkan profil finisher</i></p>
                <p v-else-if="item.lastMessage.attachment">
                  <i>{{item.lastMessage.name}} mengirimkan foto</i></p>
              </div>
              <div class="muted" v-if="item.muted"></div>
              <div class="ntf" v-if="item.unreadCount > 0">
                {{item.unreadCount}}
              </div>
              <timeago :datetime="item.lastMessage.timestamp * 1000"
                v-if="item.lastMessage && item.lastMessage.timestamp"></timeago>
              <div class="more" v-on:click.stop="moreId = item.id"></div>
              <div class="ddCnt" v-if="moreId === item.id"
                v-on:click.stop="doNothing">
                <div class="ddItem" v-on:click.stop="editData(i, item)">Edit grup</div>
                <div class="ddItem" v-on:click.stop="inviteMember(i, item)">Undang peserta</div>
                <div class="ddItem" v-if="item.muted === 1"
                  v-on:click.stop="unmuteGroup(i, item)">Nyalakan notifikasi</div>
                <div class="ddItem" v-else
                  v-on:click.stop="muteGroup(i, item)">Matikan notifikasi</div>
                <div class="divider"></div>
                <div class="ddItem red"
                  v-on:click.stop="leaveGroup(i, item)">Keluar dari grup</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <CreateGroup ref="createGroup"/>
    <ChatGroupDetail ref="chatGroupDetail"/>
    <Snackbar ref="snackbar"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import CreateGroup from '@/components/CreateGroup.vue';
import ChatGroupDetail from '@/components/ChatGroupDetail.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'chatGroup',
  components: {
    Confirmation,
    CreateGroup,
    ChatGroupDetail,
    Snackbar,
  },
  data() {
    return {
      point: 0,
      show: false,
      groups: [],
      loading: true,
      moreId: null,
      notifSound: null,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      this.moreId = null;
    },
    open() {
      this.show = true;
      this.getData();
    },
    close() { this.show = false; },
    openDetail(i, item) {
      this.$refs.chatGroupDetail.open(item, (b, v) => {
        this.getData();
      });
    },
    createGroup() {
      this.$refs.createGroup.open(null, false, () => {
        this.getData();
      });
    },
    editData(i, item) {
      this.moreId = null;
      this.$refs.createGroup.open(item, false, () => {
        this.getData();
      });
    },
    inviteMember(i, item) {
      this.moreId = null;
      this.$refs.createGroup.open(item, true, () => {
        this.getData();
      });
    },
    muteGroup(i, item) {
      this.moreId = null;
      this.$refs.confirmDialog.open({
        title: 'Matikan Notifikasi',
        desc: `Jika kamu mematikan notifikasi untuk grup ini, tidak akan ada suara ketika
          ada pesan baru.`,
        action: 'Matikan Notifikasi',
      }, (b) => {
        if (!b) return;
        this.groups[i].muted = 1;
        this.$http.get(this.$config.uri(`group/${item.id}/mute`));
      });
    },
    unmuteGroup(i, item) {
      this.moreId = null;
      this.$refs.confirmDialog.open({
        title: 'Nyalakan Notifikasi',
        desc: `Jika kamu menyalakan notifikasi untuk grup ini, akan ada suara ketika
          ada pesan baru.`,
        action: 'Nyalakan Notifikasi',
      }, (b) => {
        if (!b) return;
        this.groups[i].muted = 0;
        this.$http.get(this.$config.uri(`group/${item.id}/unmute`));
      });
    },
    leaveGroup(i, item) {
      this.moreId = null;
      this.$refs.confirmDialog.open({
        title: 'Keluar Dari Grup',
        desc: `Apakah kamu yakin ingin keluar dari grup ini?
          Grup dan isi percakapan akan dihapus dari daftar grup kamu.`,
        action: 'Keluar Grup',
      }, (b) => {
        if (!b) return;
        this.groups.splice(i, 1);
        this.$http.get(this.$config.uri(`group/${item.id}/leave`));
      });
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri('group/all')).then((r) => {
        this.loading = false;
        this.groups = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {
    this.notifSound = new Audio(`${this.$config.cdnUri}media/notif.mp3`);
    this.notifSound.volume = 0.2;
    this.sockets.unsubscribe('broadcast');
    this.sockets.subscribe('broadcast', (data) => {
      // eslint-disable-next-line
      for (const g of this.groups) {
        if (g.id === data.groupId) {
          if (g.muted === 0) this.notifSound.play();
          g.unreadCount += 1;
          g.lastMessage = data;
        }
      }
    });
  },
};
</script>

<style scoped lang="scss">
.section.chatGroup{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;

    background-color: #fff;
    // background-color: #e6e1c1;
    // background-color: #b7e4c9;
    // background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 480px;
    z-index: 3;
    right: -480px;
    transition: all .45s ease;
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      // background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 0 20px;
    height: 60px;
    display: flex;
    align-items: center;
    z-index: 7;
    border-bottom: #eee 1px solid;
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    .createGroup{
      border: none;
      border-radius: 50px;
      padding: 8px 16px;
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;
      transition: all .3s ease;
      background-color: #5351a4;
      &:hover{
        background-color: #615fb1;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: auto;
      padding: 0 10px 0 20px;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 60px 0 10px;
  }
  .loadingGroup{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    background-image: url(../assets/loading.svg);
    background-size: 38px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  .noGroup{
    position: absolute;
    top: 50%; left: 30px; right: 30px;
    transform: translateY(-50%);
    text-align: center;
    img{
      width: 120px;
    }
    h4{
      margin: 10px 0 4px;
      font-size: 17px;
    }
    p{
      margin: 0 0 20px;
      font-size: 14px;
    }
    button{
      background-color: #8EC642;
      border: none;
      border-radius: 50px;
      padding: 10px 24px;
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #7db92d;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
      }
    }
  }
  .groupCnt{
    padding: 0 0 40px;
    .divider{
      height: 20px;
    }
    .groupItem{
      padding: 12px 20px;
      padding-left: 78px;
      font-weight: bold;
      display: block;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .5);
      backdrop-filter: blur(20px);

      border-bottom: #eee 1px solid;

      margin: 0 0 1px;
      // border-radius: 5px;
      transition: all .3s ease;
      cursor: pointer;
      z-index: 3;
      box-sizing: border-box;
      min-height: 64px;
      &.moreOpen{
        z-index: 7;
      }
      &:hover{
        background-color: rgba(255, 255, 255, .8);
      }
      &:active{
        background-color: #ddd;
      }
      .muted{
        position: absolute;
        width: 20px; height: 20px;
        right: 60px; top: 10px;
        background-image: url(../assets/notifications_off_black_24dp.svg);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .65;
      }
      .ntf{
        width: auto;
        min-width: 19px;
        height: 19px;
        background-color: #F76B21;
        border-radius: 10px;
        font-size: 11px;
        display: inline-block;
        text-align: center;
        font-weight: bold;
        position: absolute;
        padding: 3px 5px 0;
        box-sizing: border-box;
        color: #fff;
        position: absolute;
        right: 30px; top: 10px;
      }
      .more{
        position: absolute;
        right: 4px; top: 7px;
        width: 26px; height: 26px;
        background-position: center;
        border-radius: 50%;
        background-size: 14px auto;
        background-repeat: no-repeat;
        background-image: url(../assets/more-veritcal.png);
        transition: all .3s ease;
        cursor: pointer;
        z-index: 9;
        &:hover{
          background-color: #fff;
        }
      }
      .ddCnt{
        position: absolute;
        background-color: #fff;
        padding: 10px 0;
        z-index: 97;
        border-radius: 5px;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
        right: 10px; top: 30px;
        .divider{
          border-top: #eee 1px solid;
          margin: 10px 0;
          height: auto;
        }
        .ddItem{
          padding: 8px 24px;
          font-size: 15px;
          font-weight: 400;
          cursor: pointer;
          transition: all .3s ease;
          &.red{
            color: red;
          }
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
      time{
        position: absolute;
        bottom: 13px; right: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #767676;
      }
      h4{
        margin: 0;
        font-size: 17px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 40px;
      }
      p{
        font-size: 14px;
        font-weight: 400;
        margin: 0;
        color: #767676;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 140px;
      }
      .groupAvatar{
        position: absolute;
        left: 20px; top: 12px;
        width: 44px; height: 44px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #ccc;
        border-radius: 50%;
        &.noImg{
          background-image: url(../assets/image-black.png) !important;
          background-size: 18px auto;
          opacity: .35;
        }
      }
    }
  }
}
</style>
